(() => {
  const btn = document.querySelector('.js-veys-top');
  if (!btn) return;

  // PDP: the sticky add-to-cart panel (position "end") shares the bottom-right
  // corner and its height varies with the product title, so the static 88px
  // clearance in custom.css is only a pre-JS fallback. While the panel is
  // shown, sit 12px above it (offsetHeight + 20px panel margin + 12px gap).
  const atcPanel = document.querySelector('.sticky-atc-panel');

  let ticking = false;
  const toggle = () => {
    btn.classList.toggle('is-visible', window.scrollY > 600);
    if (atcPanel) {
      const shown = !atcPanel.classList.contains('sticky-atc-panel--out') &&
        !document.body.classList.contains('scrolled-to-bottom') &&
        getComputedStyle(atcPanel).display !== 'none';
      btn.style.bottom = shown ? atcPanel.offsetHeight + 32 + 'px' : '';
    }
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(toggle);
    }
  }, { passive: true });
  // The panel's show/hide class flips in an IntersectionObserver callback,
  // i.e. after our scroll handler has already run — re-sync when it changes.
  if (atcPanel && 'MutationObserver' in window) {
    new MutationObserver(toggle).observe(atcPanel, { attributes: true, attributeFilter: ['class'] });
  }
  toggle();

  btn.addEventListener('click', () => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
})();
